
import { initializeCommand } from '../index';
import { buildServices } from '../services';

export const command = 'build';
export const describe = `Build the environment variables for each service.`;

export const builder = () => {
  initializeCommand();
};

export const handler = async(): Promise<void> => {
  await buildServices();
};